import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    templateUrl: './error-message.component.html',
    styleUrls: ['./error-message.component.scss'],
    imports: [MatButtonModule, AsyncPipe, TranslateModule,MatIcon]
})
export class ErrorMessageComponent {
  constructor(private matSnackBarRef: MatSnackBarRef<ErrorMessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public message: Observable<string>) {
  }

  protected dismiss(): void {
    this.matSnackBarRef.dismiss();
  }
}
